/**
 * Compose-local helpers for the two things neither the store nor the i18n layer provides
 * (reported as gaps in the compose stream):
 *
 * - the `tik.composeFull` preference behind the full-page/docked toggle (spec §1.5 item 2),
 *   which the legacy `ui.js` kept in localStorage outside the store's `LS` map;
 * - the toggle's labels, which lived only in `ui.js` and are absent from `ar.json`/`en.json`.
 */
import type { Lang } from '$lib/i18n';

export const COMPOSE_FULL_KEY = 'tik.composeFull';

/** `'1'` or absent = full page, `'0'` = docked window (legacy `isFull`). */
export function readComposeFull(): boolean {
  try {
    return localStorage.getItem(COMPOSE_FULL_KEY) !== '0';
  } catch {
    return true;
  }
}

export function writeComposeFull(full: boolean): void {
  try {
    localStorage.setItem(COMPOSE_FULL_KEY, full ? '1' : '0');
  } catch {
    /* private mode / quota: the in-memory state still toggles */
  }
}

const FULL_LABELS: Readonly<Record<Lang, { full: string; dock: string }>> = Object.freeze({
  ar: { full: 'تصغير إلى نافذة', dock: 'ملء الصفحة' },
  en: { full: 'Shrink to window', dock: 'Full page' },
});

/** Label of the `.tik-fullbtn`: describes the action, so "shrink" while full, "full page" while docked. */
export function fullButtonLabel(full: boolean, lang: Lang): string {
  return FULL_LABELS[lang][full ? 'full' : 'dock'];
}
